<template>
  <div>
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :getItemColor="getItemColor"
      :coloredFields="['status']"
      :tableKey="tableKey"
      :onDataReceived="onDataReceived"
      :activeTab="activeTab"
      :noDelete="false"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapLegend="mapLegend"
      :editable="editable"
      :allEditable="false"
      :onMarkerClick="onMarkerClick"
      :showGroupBy="true"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :isDraggable="tableDraggable"
      :objKey="objKey"
      :mapLoading="mapLoading"
      :filterTabs="filterTabs"
      :singleSelect="singleSelect"
      :hasSearch="true"
      :tableName="tableName"
      :alwaysUpdate="true"
      :editRow="true"
      :tblVBind="vBind"
      :editedItemTitle="editedItemTitle"
      addButtonCaption="Add New Trip"
      :showFullTable="true"
      :defaultTab="0"
      :resourceVBind="resourceVBind"
      :dataTemplate="dataTemplate"
      :customDayClick="dayClick"
      :resourceInsteadOfTable="true"
      calTabTitle="Trip Calendar"
      tableTabTitle="All Trips"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";

export default {
  name: "TripDispatch",
  components: {
    // VCombo: () => import("../components/ComboBox.vue"),
    VCalTblMap: () => import("../components/CalTblMap.vue")
  },
  props: {},
  data() {
    return {
      d: null,
      objKey: 0,
      mapTitle: "Trip Map",
      curAgent: "",
      defaultEventColor: "#137C15FF",
      data_object: null,
      singleSelect: false,
      // activeTab: 0,
      dateField: "date",
      link: {
        field: "shipment_id",
        name: "shipment"
      },
      mapData: [],
      dataTable: [],
      fullData: [],
      width: 4,
      tableDraggable: true,
      filterTabs: [],
      editable: [
        // "trip_name",
        // "etd",
        // "status",
        // "trip_type",
        // "orig_warehouse",
        // "dest_warehouse",
        // "haul_type",
        // "agent",
      ],
      selectedTrip: null,
      warehouse: [],
      tripJobs: [],
      tripCustomers: [],
      reordered: null,
      tableName: "Trip",
      vBind: null,
      editedItemTitle: ["trip_name"],
      resourceVBind: {
        dataTitle: "shipment_id",
        data: [],
        time: [
          // { value: "all day", start: 0, end: 24 },
          // { value: "morning", start: 0, end: 12 },
          // { value: "afternoon", start: 12, end: 18 },
          // { value: "evening", start: 18, end: 24 },
        ],
        timeName: "etd",
        resourceName: "Assign Jobs",
        dataName: "Unassigned Jobs",
        scheduledDataName: "Assigned Jobs",
        addBtnTitle: "Add Crew",
        resourceTitle: "full_name",
        resourceSchema: {},
        dataResource: "trip",
        resourceLink: {
          field: "employee_id",
          name: "employee"
        },

        resourceLinkClick: function(item) {
          this.$root.addResentTab(item);
        },

        link: "shipment_id",
        selectedTripId: null,
        deliveryStatus: null,
        itineraryStatus: null
      }
    };
  },
  mounted() {
    var that = this;
    window.openTab = function(item) {
      that.$root.addResentTab(item);
    };
    this.$root.$on("tableSelectionChanged", t => {
      // var curRec = fun.getParentByProperty(t, "openButtonTitle").parentModel;
      if (t.tableName == that.tableName) {
        if (
          t.selected[0] &&
          (!that.selectedTrip || that.selectedTrip[0]._id != t.selected[0]._id)
        ) {
          that.selectedTrip = t.selected;
          that.createTripMapData();
        }
      }

      // that.updateTable({ item: curRec });
    });
    // this.$root.$on("tableItemChanged", (t) => {
    //   console.log(t);
    //   if (t.tbl.k == "trip_jobs") {
    //     var data = [];
    //     data.push({
    //       collection: "shipment",
    //       // id_fields: ["estimate.non-binding.shipment_service.itinerary._id"],
    //       qry: {
    //         shipment_id: t.item.shipment_id,
    //         "estimate.non-binding.shipment_service": {
    //           $elemMatch: { _id: t.item.service_id },
    //         },
    //       },
    //       update: {
    //         "estimate.non-binding.shipment_service.$[s].loadboard_price":
    //           t.item.loadboard_price,
    //         "estimate.non-binding.shipment_service.$[s].hauler_due":
    //           t.item.hauler_due,
    //         "estimate.non-binding.shipment_service.$[s].carrier_due":
    //           t.item.carrier_due,
    //         "estimate.non-binding.shipment_service.$[s].agent_collect":
    //           t.item.agent_collect,
    //       },
    //       array_filters: [
    //         {
    //           "s._id": t.item.service_id,
    //         },
    //         // {
    //         //   "i._id": t.item.next_stop._id,
    //         // },
    //       ],
    //     });
    //     axios
    //       .post(this.serverURL + "/modify_value", data, {
    //         withCredentials: true,
    //       })
    //       .then((r) => {
    //         console.log(r.data);
    //       });
    //   }
    //   //
    // });

    this.$root.$on("tableMounted", t => {
      // console.log(t);
      if (t.k == "trip_jobs") {
        t.linkClick = this.linkClick;
      }
    });
    this.$root.$on("rowReordered", t => {
      if (t.$parent.tableName == "trip_jobs") {
        that.reordered = t.$parent.table;
        that.reordered.forEach((r, i) => {
          r.stop_number = i + 1;
        });
        t.$parent.loading = true;
        that.$refs.calTblMap.mapLoading = true;
        that.createTripMapData(that.reordered, function() {
          t.$parent.loading = false;
          that.$refs.calTblMap.mapLoading = false;
        });
      }
    });
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    reloadResources() {
      this.getData();
    },
    updateTableRecord(t) {
      var itineraryKey =
        "estimate." + t.item.estimate_key + ".shipment_service.0.itinerary.1";
      var itineraryUpdate = {};
      var isNew = false;

      var update = {
        trip: t.item.trip,
        _id: t.item.next_stop._id
      };

      var d = { add: [], update: [], delete: [] };

      d[isNew ? "add" : "update"] = [update];

      var updateData = {};
      updateData[itineraryKey] = {
        id_fields: ["agent._id", "warehouse._id", "_id"],
        update_data: d
      };
      var data = {
        metadata: { object_name: "shipment", update_only: true },
        update: updateData,
        model: { _id: t.item.cid },
        _id: t.item.cid
      };
      return data;
    },
    doAssign(v, _id) {
      // console.log(v);
      // console.log(_id);
      // console.log(this.resourceVBind.data);
      var data = [];

      var rec = this.resourceVBind.data.filter(r => {
        return r._id == _id;
      })[0];
      if (v) {
        rec.trip = { _id: v._id, trip_name: v.trip_name };
      } else {
        rec.trip = null;
      }
      data.push(this.updateTableRecord({ item: rec }));

      // this.tableKey = !this.tableKey;

      axios
        .post(this.serverURL + "/add_bulk_data", data, {
          withCredentials: true
        })
        .then(r => {
          this.successMessage = r.data;
        });
    },
    dayClick(d, c) {
      console.log(d);
      this.d = d;

      // c.dayClicked = true;
      // c.resourceReady = true;
      // c.activeTab = 1;
    },
    dataTemplate: function(d) {
      var borderColorPickupStatus = "";
      var borderColorDeliveryStatus = "";
      try {
        borderColorDeliveryStatus = this.deliveryStatus.find(s => {
          return s.status == d.delivery_status;
        }).color;
        borderColorDeliveryStatus = borderColorDeliveryStatus.replace(
          "##",
          "#"
        );
      } catch (error) {
        //
      }
      try {
        borderColorPickupStatus = this.itineraryStatus.find(s => {
          return s.status == d.pickup_status;
        }).color;
        borderColorPickupStatus = borderColorPickupStatus.replace("##", "#");
      } catch (error) {
        //
      }
      var template = `
    
      <b> <a href="javascript:openTab({shipment_id: ${
        d.shipment_id
      },customer_name: '${d.customer_name}'})"> <b>#${d.shipment_id}</b><br>
             <b>${d.customer_name}</a></b><br>
             From <b>${d.origin ? d.origin.address.city : ""}, ${
        d.origin ? d.origin.address.stateCode : ""
      }</b> <br>
             To: <b>${d.destination ? d.destination.address.city : ""}, ${
        d.destination ? d.destination.address.stateCode : ""
      } </b><br>
             Pickup Date: ${fun.formatDate(d.service_date)}<br>
             Volume/Weight:${d.volume}/${d.weight}<br>
             Pickup Status: <div style="padding:5px; background-color: ${borderColorPickupStatus}; color:${fun.getReadableTextColor(
        borderColorPickupStatus
      )}" > ${fun.capitalize(d.pickup_status)}</div>
             Delivery Status: <div style="padding:5px; background-color: ${borderColorDeliveryStatus}; color:${fun.getReadableTextColor(
        borderColorDeliveryStatus
      )}" > ${fun.capitalize(d.delivery_status)}
</div>
       <br/>


        `;
      return template;
    },
    resourcesAsTable(d) {
      var resourceData = [];
      this.makeResourceTable(d, resourceData);
      return this.makeResourceMap(resourceData, d);
      // return this.generateResourceHTMLTable(resourceData);
    },
    makeResourceTable(dd, resourceData) {
      if (dd.resources) {
        this.resourceType.forEach(t => {
          var res = dd.resources.filter(r => {
            return r.resource_type == t.resource_type;
          });
          if (res.length) {
            if (res[0].qty) {
              var assignedQty = 0;
              if (dd.day_crew) {
                if (t.resource_type == "mover" && dd.day_crew.crew_employee) {
                  assignedQty = dd.day_crew.crew_employee.length;
                }
                if (t.resource_type != "mover" && dd.day_crew.resources) {
                  assignedQty = dd.day_crew.resources.filter(c => {
                    return c.resource_type == t.resource_type;
                  }).length;
                }
              }
              resourceData.push({
                resource: t.resource_type,
                qty: res[0].qty,
                assignedQty: assignedQty
              });
            }
          }
        });
      }
    },

    getData() {
      var that = this;
      var data_object = {
        object_name: "v_schedule_cal",
        schema_name: "ld_dispatch",
        qry: {
          service_type: "long_distance_moving"
        }
      };

      axios
        .post(this.serverURL + "/get_data", data_object, {
          withCredentials: true
        })
        .then(response => {
          this.resourceVBind.data = response.data.model;
          that.$refs.calTblMap.resourceKey = !that.$refs.calTblMap.resourceKey;
        });
    },
    updateTable(t, f) {
      var that = this;

      var data = {
        metadata: {
          object_name: "trip"
        },
        model: t.item
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(r => {
          if (f) {
            f(r);
          }
        });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    getItemColor(e, slot, item, tableName) {
      var color = "";
      switch (slot) {
        case "status":
          if (e) {
            try {
              color = this.statuses.filter(f => {
                return f.status == e;
              })[0].color;
            } catch (error) {
              console.log(error);
            }
          }
          break;

        case "trip_name":
          return "";

        default:
          break;
      }
      return color;
    },
    eventTemplate: function(e, data, obj) {
      var eventColor = e.color;
      if (e.customer && e.customer.address) {
        var address = "",
          ev,
          serviceDate;

        e.orig_city = e.origin.city;
        e.orig_state = e.origin.stateCode;
        address = e.orig_city + ", " + e.orig_state;

        e.dest_city = e.destination.city;
        e.dest_state = e.destination.stateCode;
        address = e.dest_city + ", " + e.dest_state;
        // }
      }

      serviceDate = new Date(e.service_date);

      var endTime = serviceDate.addHours(1);
      if (e.etd) {
        serviceDate = new Date(e.etd);
      }
      var name = e.trip_name + " " + e.trip_type;
      if (e.orig_warehouse) {
        name += " " + e.orig_warehouse.warehouse_name;
      }
      if (e.origin) {
        name += " " + e.origin;
      }
      if (e.agent) {
        name += " " + e.agent.company;
      }
      if (serviceDate) {
        ev = {
          name: name,
          start: serviceDate,
          id: e._id,
          // end: fun.formatDateTime(endTime),
          timed: false,
          color: e.color
        };

        return ev;
      }

      return ev;
    },
    getTripRoute(trip, feedback) {
      var that = this;

      axios
        .post(
          this.serverURL + "/get_data",
          { object_name: "v_trip", qry: { _id: trip._id } },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var data = response.data;
          var table = that.$refs.calTblMap.$refs.dTable;
          // this.$refs.calTblMap.tblVBind = data.schema["v-bind"];
          // that.$refs.calTblMap.$refs.dTable.editedItemTitle =
          //   data.schema["v-bind"].editedItemTitle;
          // data.schema["v-bind"].editedItemTitle.tblVBind.tableKey;
          // this.tableKey = !this.tableKey;
          this.tripJobs = data.model[0] ? data.model[0].trip_jobs : [];
          this.dataTable.forEach(d => {
            var dataModel = data.model.filter(m => {
              return m._id == d._id;
            })[0];
            if (dataModel) {
              d.trip_jobs = dataModel.trip_jobs;
            }
          });
          table.table = this.dataTable;
          if (this.tripJobs.length) {
            that.$refs.calTblMap.mapReady = true;
          } else {
            that.$refs.calTblMap.mapReady = false;
          }
          feedback(data.model[0] ? data.model[0].route : null);
        });
    },

    createTripMapData(reorder, feedback) {
      var that = this;
      that.mapData = [];

      if (!this.selectedTrip || !this.selectedTrip.length) {
        that.$refs.calTblMap.mapLoading = false;
        return;
      }
      var curTrip = this.selectedTrip[0];
      if (!reorder) {
        that.$refs.calTblMap.mapReady = true;
        that.$refs.calTblMap.mapLoading = true;
      }
      this.getTripRoute(curTrip, route => {
        that.$refs.calTblMap.mapLoading = false;
        if (route) {
          if (route[0].waypoints.length < that.tripJobs.length + 1) {
            route = null;
          } else {
            route[0].waypoints.forEach((w, i) => {
              if (i > 0) {
                var jobExist = that.tripJobs.filter(j => {
                  return (
                    j.destination.address.label == w.address ||
                    (j.next_stop &&
                      j.next_stop.warehouse &&
                      j.next_stop.warehouse._id == w.warehouse_id)
                  );
                });
                if (!jobExist.length) {
                  route = null;
                }
                // var tripJob = that.tripJobs[i - 1];
                // if (w.address != tripJob.destination.address.label) {

                // }
              }
            });
          }
        }
        curTrip.route = route;

        var whs;

        if (curTrip.orig_warehouse) {
          whs = this.warehouse.filter(w => {
            return w._id == curTrip.orig_warehouse._id;
          });
          if (whs.length) {
            if (whs[0].geo && whs[0].address) {
              this.mapData.push({
                pos: {
                  lat: whs[0].geo.position[0],
                  lng: whs[0].geo.position[1]
                },
                label: whs[0].warehouse_name,
                address: whs[0].address.address,
                shortLabel: '<div class="mdi mdi-forklift"></div>',
                markerColor: whs[0].color,
                warehouseId: whs[0]._id,
                extraClass: ["square"]
              });
            }
          }
        }
        // curTrip.route = null;
        if (reorder) {
          curTrip.route = null;
        }

        if (!curTrip.route) {
          if (!reorder) {
            this.tripJobs.forEach((j, i) => {
              var stops = j.stops;
              var label =
                j.first_name + " " + j.last_name + " #" + j.shipment_id;
              var addr;

              if (j.next_stop && j.next_stop.warehouse) {
                var curWhs = this.warehouse.filter(w => {
                  return w._id == j.next_stop.warehouse._id;
                });
                if (curWhs.length) {
                  var samePoint = this.mapData.filter(m => {
                    return (
                      m.pos.lat == curWhs[0].geo.position[0] &&
                      m.pos.lng == curWhs[0].geo.position[1]
                    );
                  });
                  if (!samePoint.length) {
                    this.mapData.push({
                      pos: {
                        lat: curWhs[0].geo.position[0],
                        lng: curWhs[0].geo.position[1]
                      },
                      label: label,
                      address: curWhs[0].address.address,
                      shortLabel: '<div class="mdi forklift"></div>',
                      warehouse_id: curWhs[0]._id,

                      _id: j._id,
                      service_id: j.service_id,
                      markerColor: this.getTripColor(curTrip) || ""
                    });
                  } else {
                    samePoint[0].label += "; \n" + label;
                  }
                }
              } else {
                if (j.destination) {
                  this.mapData.push({
                    pos: {
                      lat: j.destination.position[0],
                      lng: j.destination.position[1]
                    },
                    label: label,
                    address: j.destination.address.label,
                    shortLabel: '<div class="mdi mdi-home-circle"></div>',
                    color: "white",
                    warehouse_id: j.next_stop.warehouse
                      ? j.next_stop.warehouse._id
                      : "",

                    _id: j._id,
                    service_id: j.service_id,
                    markerColor: this.getTripColor(curTrip) || ""
                  });
                  // }
                }
              }
            });
          }
          if (whs.length) {
            var firstStop = whs[0];
            firstStop.pos = {
              lat: firstStop.geo.position[0],
              lng: firstStop.geo.position[1]
            };
          }

          if (!reorder) {
            this.mapData = this.getSequence(this.mapData, whs[0]);
          } else {
            reorder.unshift(this.mapData[0]);
          }

          this.calculateTripRoute(reorder, function() {
            that.prepareTripLegend(curTrip);
            if (feedback) {
              feedback();
            }
          });
        } else {
          this.mapData = curTrip.route;
          that.prepareTripLegend(curTrip);
        }
      });
    },
    getSequence(data, firstStop, filter) {
      // var mileage = 10000;
      var filtered = data;
      if (filter) {
        filtered = data.filter(r => {
          return eval(filter);
        });
      }
      filtered.forEach(d => {
        if (d.pos) {
          d.mileage = fun.mileage(
            firstStop.pos.lat,
            firstStop.pos.lng,
            d.pos.lat,
            d.pos.lng
          );
        }
      });
      fun.sortObjects(filtered, "mileage");
      return filtered;
    },
    prepareTripLegend(curTrip) {
      this.getTripsMapData(
        this.prepareTripWaypoints(
          curTrip,
          fun.clone(this.mapData[0].waypoints),
          this.tripJobs,
          this.mapData[0].mapLine.service.route.leg
        ),
        {
          stop_number: {
            title: " "
          },

          delivery_date_range: {
            title: "Del. Range"
          },
          eta: {},
          label: {
            title: "Customer"
          },
          driving_time: {
            title: "Drv. Time"
          },
          mileage: {}
        }
      );

      this.$root.$emit("mapDataChanged", {
        data: this.mapData,
        legend: this.mapLegend,
        updateLegend: true
      });
      this.$refs.calTblMap.mapLoading = false;
    },
    calculateETA(start, drivingTime) {
      // console.log(start, drivingTime);
      var end = start.addHours(parseFloat(drivingTime));
      end = end.addHours(1);
      return end;
    },
    prepareTripWaypoints(trip, mapData, tripJobs, leg) {
      var start = new Date(trip.etd);
      if (!start.getHours()) {
        start = start.addHours(8);
      }
      var startTime = start;

      mapData.forEach((d, i) => {
        d.stop_number = i;
        if (i > 0 && leg[i - 1]) {
          var drivingTime = (leg[i - 1].travelTime / 3600).toFixed(2);
          var eta = this.calculateETA(startTime, drivingTime);
          if (tripJobs.length && tripJobs[i - 1]) {
            d.delivery_date_range = tripJobs[i - 1].delivery_date_range;
          }

          d.mileage = (leg[i - 1].length / 1.6 / 1000).toFixed(2);
          d.driving_time = drivingTime;
          d.eta = fun.formatDate(eta, false, true);
          startTime = eta;
        }
      });

      mapData.splice(0, 1);
      return mapData;
    },
    getTripsMapData(editData, properties) {
      this.mapLegend = {
        getFreshData: false,
        mobileBreakpoint: 0,
        get_table: "all",
        all_records: true,
        table_title: "Trips Jobs",
        tableName: "trip_jobs",
        hasSearch: false,
        isDraggable: true,
        // headers: ["shipment_id"],
        editData: editData,
        data_object: {
          schema: {
            properties: properties
          }
        },

        hideHeader: false,
        singleSelect: false,
        width: 4,
        disablePagination: true
      };
    },
    calculateRoute(model, fn) {
      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true
        })
        .then(response => {
          fn(response.data);
        })
        .catch(reason => {
          console.log(reason);
        });
    },
    calculateTripRoute(reorder, feedback) {
      var that = this;
      if (!that.selectedTrip.length || !that.tripJobs.length) {
        return;
      }
      var data = {
        waypoints: []
      };
      var mapData = that.mapData;

      if (reorder) {
        mapData = reorder;
      }
      mapData.forEach((w, i) => {
        if (w.pos) {
          data.waypoints.push(w.pos.lat + "," + w.pos.lng);
          if (i > 0) {
            if (w.shortLabel.toString().includes("forklift")) {
              w.extraClass = ["square"];
            }

            w.shortLabel = i;
            w.markerColor = that.mapData[0].markerColor;
            w.color = "white"; //
          }
        }
      });

      that.calculateRoute(data, r => {
        // t.tbl.customBtnLoading = false;

        that.mapData = [
          {
            mapLine: {
              service: {
                route: r[0]
              }
              // color: mapData[0].markerColor,
            },
            waypoints: mapData
          }
        ];
        var data = {
          metadata: {
            object_name: "trip"
          },
          model: {
            _id: that.selectedTrip[0]._id,
            route: that.mapData
          }
        };

        axios
          .post(this.serverURL + "/add_data", data, {
            withCredentials: true
          })

          .then(response => {
            if (reorder) {
              // that.createDataObject();
            }
          });

        feedback();
      });
    },
    getTripColor(r) {
      try {
        return this.trips.filter(t => {
          return r._id == t._id;
        })[0].color;
      } catch (error) {
        return "";
      }
    },

    getDataObject(tbl) {
      var data_object = {
        // object_name: "v_trip_no_route",
        object_name: "v_trip_no_route",
        schema_name: "v_trip",
        object_name_to_update: "trip",

        // qry: { "agent._id": this.curAgent._id },
        date_fields: ["date"],
        mobileBreakpoint: 0,
        id_fields: ["agent_id"],

        alwaysAddId: true,
        all_records: true,
        get_table: "all",
        additional_data: [
          { obj_name: "warehouse" },
          { obj_name: "trip_status" },
          { obj_name: "delivery_status" },
          { obj_name: "itinerary_status" }
          //itinerary_status
          // {
          //   obj_name: "v_sit_schedule",
          //   fields: ["first_name", "last_name", "shipment_id", "trip_id"],
          //   qry: {
          //     trip: { $ne: null },
          //   },
          // },
        ],
        additional_structure: [
          // { obj_name: "employee", schema_name: "resource_crew" },
          { obj_name: "v_trip_no_route" }
        ],

        table_title: "Trips",
        hasSearch: true
      };
      return data_object;
    },

    onMarkerClick(data, e) {
      var topElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];

      var unassign = false;
      var msg = "";

      if (
        data.legend.selected[0] &&
        topElement.innerHTML == data.legend.selected[0].employee_id
      ) {
        unassign = true;
      }
      msg =
        "Confirm assigning " +
        data.legend.selected[0].full_name +
        " to #" +
        data.shipment_id +
        "?";

      if (unassign) {
        msg = "Confirm unassigning #" + data.shipment_id + "?";
      }

      data.foreman = {
        _id: data.legend.selected[0]._id,
        full_name: data.legend.selected[0].full_name
      };
      this.dataTable.filter(r => {
        return r._id == data._id;
      })[0].foreman = data.foreman;
      this.updateTable({ item: data }, resp => {
        if (data.foreman) {
          this.updateForemanOnMap(data, topElement);
        }
      });
    },
    createDataTrip(data) {
      console.log(data.table);
      this.filterTabs = [];
      if (data.additional_model) {
        this.statuses = data.additional_model.trip_status;
        this.tripCustomers = data.additional_model.v_sit_schedule;
        this.statuses.forEach(s => {
          this.filterTabs.push({
            caption: fun.capitalize(s.status),
            name: "status",
            value: s.status,
            color: s.color
          });
        });
      }

      this.filterCondition = "";

      this.dataTable.forEach(r => {
        if (this.tripCustomers) {
          var tripCustomers = this.tripCustomers.filter(c => {
            return c.trip_id == r._id;
          });

          var tripJobs = "";
          tripCustomers.forEach(a => {
            tripJobs +=
              " " +
              a.first_name +
              " " +
              a.last_name +
              "#" +
              a.shipment_id +
              "<br>";
            // var lines = tripJobs.split(/\r\n|\r|\n/g);
            // console.log(lines)
          });
          r.num_jobs = tripCustomers.length;
        }
        r.trip_jobs = tripJobs;

        switch (r.trip_type) {
          case "d2w":
            break;
          case "w2w":
          case "w2d":
            if (r.orig_warehouse) {
              r.origin = "warehouse: " + r.orig_warehouse.warehouse_name;
            }
            if (r.dest_warehouse) {
              r.destination = "warehouse: " + r.dest_warehouse.warehouse_name;
            }

            break;

          case "d2d":
            break;
          default:
            break;
        }
      });
    },
    updateForemanOnMap(data, topElement) {
      var curForeman = this.foreman.filter(f => {
        return f._id == data.foreman._id;
      });
      if (curForeman[0]) {
        topElement.innerHTML = curForeman[0].employee_id;
        topElement.style.backgroundColor = curForeman[0].color;
        topElement.style.display = "block";
      }
    },
    eventClick(e, cal) {
      console.log(e);
      this.selectedTripId = e.event.id;
      // cal.resourceKey = !cal.resourceKey;

      // this.dataTable = fun.clone(this.fullData);
      // this.dataTable = this.dataTable.filter((d) => {
      //   return d._id == e.event.id;
      // });
      // this.singleSelect = true;
      // this.selectedTrip = this.dataTable;
      // this.$refs.calTblMap.tableData = this.dataTable;
      // this.$refs.calTblMap.tableReady = true;
      this.$refs.calTblMap.activeTab = 1;
      // this.createTripMapData();
      // this.$refs.calTblMap.dayClick();
    },
    getLocation(r, stopType) {
      var stops = r.stops;
      var st = stops.filter(s => {
        return s.value == stopType;
      })[0];
      if (st) {
        var location = r.customer.address.filter(a => {
          return a.full_address == st.full_address;
        })[0];
        if (location && location.location.address.geo) {
          location = location.location.address.geo;
        }
        return location;
      }
    },

    onDataReceived(data, d) {
      console.log(data);
      var that = this;
      var f = fun;
      this.mapData = [];
      if (d) {
        this.d = d;
      } else {
        d = this.d;
      }
      try {
        this.warehouse = data.additional_model.warehouse;
      } catch (error) {
        //
      }
      try {
        this.deliveryStatus = data.additional_model.delivery_status;
      } catch (error) {
        //
      }
      try {
        this.itineraryStatus = data.additional_model.itinerary_status;
      } catch (error) {
        //
      }
      try {
        this.tripCustomers = data.additional_model.v_sit_schedule;
      } catch (error) {
        //
      }
      // if (this.d) {
      //   data.model = data.model.filter((m) => {
      //     return (
      //       f.formatDate(m.etd, false, false, true) ==
      //       f.formatDate(that.d, false, false, true)
      //     );
      //   });

      //   this.d = null;
      // }
      this.createDataTrip(data);
      // this.resourceVBind.data = this.dataTable;
      this.resourceVBind.resources = [];
      if (data.additional_structure) {
        this.resourceVBind.resourceSchema =
          data.additional_structure.v_trip_no_route;
        // this.resourceVBind.resourceSchema.date_fields = ["date"];
        // this.resourceVBind.resourceSchema.object_name = "v_trip_no_route";
        // this.resourceVBind.resourceSchema.object_name_to_update = "trip";
      }

      // this.resourceVBind.additionalModel = {
      //   // vehicle_type: data.additional_model.vehicle_type,
      //   // employee_role: data.additional_model.employee_role,
      // };
      // this.resourceVBind.getQry = function(res) {
      //   if (that.d) {
      //     return {
      //       date: {
      //         $gte: fun.formatDate(that.d, true, null, true),
      //         $lte: fun.formatDate(that.d, true, null, true),
      //       },
      //     };
      //   } else {
      //     return {};
      //   }
      // };
      this.resourceVBind.allRecords = true;
      this.resourceVBind.update = this.doAssign;
      this.resourceVBind.resourceFilter = function(data) {
        data.table.forEach(t => {
          var type = t.trip_type.split("2");

          t.icon = fun.getItineraryIcon(type[0]);
          t.icon2 = fun.getItineraryIcon(type[1]);
          // "<span class='large-icon>'<i class='mdi mdi-warehouse'></i></span>";
        });
        data.model = data.table;
        if (that.d) {
          data.table = data.table.filter(m => {
            return (
              f.formatDate(m.etd, false, false, true) ==
              f.formatDate(that.d, false, false, true)
            );
          });

          that.d = null;
          return data;
        }
        if (that.selectedTripId) {
          data.table = data.table.filter(m => {
            return m._id == that.selectedTripId;
          });
          // data.model = data.table;
          that.selectedTripId = null;
          return data;
        }
        return data;
      };

      if (d) {
        var serviceDate = fun.getFullDate(d);
        this.dataTable = data.model.filter(m => {
          return fun.getFullDate(new Date(m.date)) == serviceDate;
        });

        return this.dataTable;
      } else {
        this.fullData = data.model;
        return data.model;
      }

      // return data.model;
    },
    replaceColor(obj) {
      var classes = "";
      if (obj) {
        obj.forEach(s => {
          try {
            if (s.color && s.color.replace) {
              if (s.color.length == 9 && s.color[0] == "#") {
                s.color = s.color.substr(0, 7);
              }
              var className = "color-" + s.color.replace("#", "");
              var classCss =
                "background-color:" + s.color + "; color:" + "white";
              // fun.invertColor(s.color);
              var cl = "\n." + className + " { " + classCss + "}";
              if (classes.indexOf(cl) == -1) {
                classes += cl;
              }
            }
          } catch (error) {
            console.log(error);
          }
        });
        this.$root.dynamicClasses(classes);
      }
    }
  }
};
</script>

<style lang="css" scoped></style>
